/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
var core_1 = require('@angular/core');
exports.ReflectionCapabilities = core_1.__core_private__.ReflectionCapabilities;
exports.reflector = core_1.__core_private__.reflector;
//# sourceMappingURL=core_private.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/platform-browser-dynamic/core_private.js
// module id = 318
// module chunks = 2